module.exports = __webpack_public_path__ + "img/cloud-icon.9e11b7d6.svg";